import { render, staticRenderFns } from "./SearchToggleButton.vue?vue&type=template&id=3344ded5&"
import script from "./SearchToggleButton.vue?vue&type=script&lang=js&"
export * from "./SearchToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports